export const discoverabilityOptions = [
  { label: 'Public', value: 'public' },
  { label: 'Ecosystem', value: 'ecosystem' },
  { label: 'Specific parties', value: 'party' },
  { label: 'Private', value: 'private' },
]

export const accessbilityOptions = [
  { label: 'Unrestricted', value: 'unrestricted' },
  { label: 'Upon acceptance', value: 'acceptance' },
  { label: 'Upon payment', value: 'payment', disabled: true },
  { label: 'Private', value: 'private' },
]

export const historyOptions = [
  { label: 'Latest version only', value: 'latestVersionOnly' },
  { label: 'All records to date', value: 'all' },
]

export const streamOptions = [
  { label: 'Permanent', value: 'permanent' },
  { label: 'Temporary', value: 'temporary' },
]

export const deliveryOptions = [
  { label: 'Custom', value: 'custom' },
  { label: 'In Store', value: 'dataStore' },
]

export const licensingOptions = [
  { label: 'Open without citation', value: 'no_citation' },
  { label: 'Open with citation', value: 'citation' },
  { label: 'Conditional re-use', value: 'conditional', disabled: true },
  { label: 'Private use', value: 'private' },
]
